// src/hooks/useAdminUsers.ts
import { useCallback, useEffect, useState } from 'react';
import type { AdminUser } from 'types';
import { getUsers } from 'services/usersApi';

export interface UseAdminUsersResult {
  users: AdminUser[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

/** Загружает список пользователей из `/user/all` в доменной модели `AdminUser`. */
export function useAdminUsers(): UseAdminUsersResult {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  const refetch = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getUsers()
      .then((list) => {
        if (cancelled) return;
        setUsers(list);
        setError(null);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : 'Ошибка загрузки пользователей');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return { users, isLoading, error, refetch };
}
